(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryController', WarningCategoryController);

    WarningCategoryController.$inject = ['$scope', '$state', 'WarningCategory', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function WarningCategoryController($scope, $state, WarningCategory, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.changePageSize = changePageSize;
        vm.predicates = pagingParams.predicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.currentState = "warning-category";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.loadAll();

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll() {
            WarningCategory.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            }, onSuccess, onError);


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warningCategories = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: sort(),
                search: vm.currentSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
    }
})();
